
import store from '@/store';
import { IJobs, Job } from '@/models/main';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  components: {},
  computed: {
    ...mapState(['jobData', 'storeDrivers', 'storeShowCategory']),
  },
})
export default class DriverSelect extends Vue {
  private drivers: Array<string | number> = [];
  private driversSelected: Array<string | number> = [];
  private storeDrivers!: Array<string | number>;
  private storeShowCategory!: string;
  private jobData!: IJobs;
  private updateDrivers() {
    this.drivers = [];
    let jobs: Job[] = [];
    if (this.storeShowCategory === 'all') {
      jobs = this.jobData.all;
    }
    if (this.storeShowCategory === 'unallocated') {
      jobs = this.jobData.unallocated;
    }
    if (this.storeShowCategory === 'progress') {
      jobs = this.jobData.in_progress;
    }
    if (this.storeShowCategory === 'completed') {
      jobs = this.jobData.completed;
    }
    if (this.storeShowCategory === 'cancelled') {
      jobs = this.jobData.cancelled;
    }

    jobs.forEach((job: Job) => {
      if (job.driver1 && job.driver1 !== 'NOT ALLOCATED' && this.drivers.indexOf(job.driver1) === -1) {
        this.drivers.push(job.driver1);
      }
      if (job.driver2 && job.driver2 !== 'NOT ALLOCATED' && this.drivers.indexOf(job.driver2) === -1) {
        this.drivers.push(job.driver2);
      }
    });
    this.drivers.sort((a: string | number, b: string | number): number => +a - +b);
  }
  @Watch('driversSelected')
  private changeDrivers() {
    store.dispatch('setDrivers', this.driversSelected);
  }
  @Watch('jobData')
  private changeJobs() {
    this.updateDrivers();
  }
  @Watch('storeShowCategory')
  private changeCategory() {
    this.updateDrivers();
  }
  private mounted() {
    this.updateDrivers();
    this.driversSelected = this.storeDrivers;
  }
}
